<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	export let deleteConfirm: boolean = false;
	export let buttonText: string = 'Make Claim';
	export let showClaim: boolean = false;

	const dispatch = createEventDispatcher();

	function handleEdit() {
		dispatch('edit');
	}
	function handleDelete() {
		dispatch('delete');
	}
	function handleDeleteConfirm() {
		dispatch('deleteConfirm');
	}
	function handleClaim() {
		dispatch('claim');
	}
</script>

<div class="flex gap-3 font-exo-2">
	<button
		on:click|preventDefault={handleEdit}
		class="border border-gradientBlueMid rounded-sm px-2 py-2 3xl:py-4 text-center w-24 xl:w-28 text-xs md:text-sm xl:text-lg tracking-wider bg-gradientBlueMid text-white font-bold"
		>Edit</button
	>
	{#if deleteConfirm}
		<button
			on:click|preventDefault={handleDelete}
			class="border border-gradientBlueMid rounded-sm px-2 py-2 3xl:py-4 text-center w-24 xl:w-28 text-xs md:text-sm xl:text-lg tracking-wider animate-pulse bg-gradientBlueMid text-white"
			>Confirm?</button
		>
	{:else}
		<button
			on:click|preventDefault={handleDeleteConfirm}
			class="border border-gradientBlueMid rounded-sm px-2 py-2 3xl:py-4 text-center w-24 xl:w-28 text-xs md:text-sm xl:text-lg tracking-wider text-gradientBlueMid"
			>Delete</button
		>
	{/if}
	{#if showClaim}
		<button
			on:click|preventDefault={handleClaim}
			class="border border-gradientBlueMid rounded-sm px-2 py-2 3xl:py-4 text-center md:w-28 xl:w-36 text-xs md:text-sm xl:text-lg tracking-wider text-gradientBlueMid"
			>{buttonText}</button
		>
	{/if}
</div>
